import { FC, ReactNode, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import { pathToHideNavbar, publicPaths } from "../../constants/Constants";
import { Box } from "@mui/material";
import "./Navbar.css";

interface HeaderProps {
    children: ReactNode;
}

const Header: FC<HeaderProps> = ({ children }): any => {
    const [showNavBar, setShowNavBar] = useState<boolean>(false);

    const cookies = new Cookies();
    let token: string = cookies.get("jwt");

    const location = useLocation();

    useEffect(() => {
        setShowNavBar(!pathToHideNavbar.includes(location.pathname));
    }, [location]);

    if (!publicPaths.includes(location.pathname) && showNavBar && !token) {
        return <Navigate to="/sign-in" state={{ from: location }} replace />
    }

    return (
        <Box className="navbar-global">
            {showNavBar && children}
        </Box>
    );
};

export default Header;